// extend window typing with our variable
import queryString from 'query-string';
declare global {
  interface Window {
    env: Record<string, string>;
  }
}

function getEnv(envName: string, default1: string | undefined, default2: string): string {
  // see if we have it in the window object
  if (window != null && window.env != null && window.env[envName] != null) return window.env[envName];

  const query = queryString.parse(window.location.search);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (query[envName] != null) return query[envName] as any as string;

  // in environment variables?
  if (default1 != null) return default1;

  // fall back to user specified default value
  return default2;
}
const env = {
  mainDomain: getEnv('VITE_APP_MAIN_DOMAIN', import.meta.env.VITE_APP_MAIN_DOMAIN, 'localhost:8082'),
  queryDelay: getEnv('VITE_APP_QUERY_DELAY', import.meta.env.VITE_APP_QUERY_DELAY, '0'),
  devMode: getEnv('VITE_APP_DEV_MODE', import.meta.env.VITE_APP_DEV_MODE, 'false'),
  casDomain: getEnv('VITE_CAS_DOMAIN', import.meta.env.VITE_CAS_DOMAIN, 'localhost:8100'),
};

export { env };
